// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"_Buttom_buttonWrapper__rONZK","button":"_Buttom_button__0ATYl"};